<template>
  <div class="modal-wrap">
    <div class="modal-header">
      <p class="mb-15 bold">Budgivningshistorik</p>
    </div>
    <div class="modal-content">
      <div class="grid3col grid3col--allbidhistory all-caps mb-10 fs-14">
        <div>
          Budgivare
        </div>
        <div>
          Händelse
        </div>
        <div>
          Tidpunkt
        </div>
      </div>

      <!-- bidders bids -->
      <div v-if="listOfBids">
        <div class="grid3col grid3col--allbidhistory mb-5" v-for="(bid, index) in listOfBids" :key="index">
          <div> {{ bid.bidderId }}</div>
          <div>
            <span v-if="bid.deleted">Annulerat bud<br>- </span>
            <span v-if="!bid.text">{{ $root.formatPrice(bid.amount) }} kr</span>
            <span v-if="bid.text">{{ bid.text }}</span>
          </div>
          <div> {{ bid.date.substring(0, bid.date.length-3) }}</div>
        </div>
      </div>


    </div>

    <div class="modal-buttons">
      <div class="text-center">
        <button class="width-100" @click="close">
          stäng
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'bidHistory',
  data() {
    return {
    }
  },
  computed: {
    currentListingWithBids() {
      return this.$store.getters.getCurrentActiveListing;
    },
    listOfBids() {
      /**
       * Puts all bids and their identites into a flat array
       * so we can sort by date easily.
       * @type {*[]}
       */

      let bids = [];
      this.$store.getters.getCurrentActiveListing.bidIdentities.forEach((bidder) => {
        bidder.bids.forEach((biddersBid) => {
          let temp = {
            bidderId: bidder.bidder,
          };
          temp.amount = biddersBid.amount;
          temp.date = biddersBid.date;
          temp.deleted = biddersBid.deleted;
          bids.push(temp);
        })
        if (bidder.stopped) {
          bids.push({
            bidderId: bidder.bidder,
            text: "Stannat",
            date: bidder.stoppedAt
          })
        }
      });

      return _.orderBy(bids, ['date'], ['desc']);
    }
  },
  methods: {
    close() {
      this.$root.modalOpen = false;
    }
  }
}
</script>